import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { InitiateQRPaymentComponent } from "Components/QRPayment/InitiateQRPaymentComponent";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import { useParams } from "react-router-dom";

export const InitiateQRPaymentPage = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useResource();

  if (!id) {
    return null;
  }

  return (
    <AuthenticatedLayout
      title={t(Resources.Common.QRPayment)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("dashboard"),
      }}
    >
      <StyledPageWrapper>
        <PrimaryPaper>
          <InitiateQRPaymentComponent publicID={id} />
        </PrimaryPaper>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default InitiateQRPaymentPage;
